module.exports = __webpack_public_path__ + "images/emoji/cl.009ae7210d4755777ca1.png";